import { FC } from "react";
import { useState } from "components/OrganizationsListItem";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { setAdmin, unsetAdmin } from "toolkit/users/users.thunks";
import { useParams } from "react-router-dom";
import useDebounce from "hooks/useDebounce";
import UserRolesHeader from "./UserRolesHeader/UserRolesHeader";
import UserRolesTable from "./UserRolesTable/UserRolesTable";
import SureModal from "./SureModal/SureModal";

const UserRoles: FC = () => {
	const dispatch = useAppDispatch();

	const admin = useAppSelector((state) => state.users.currentUser.admin);

	const [sureModal, setSureModal] = useState<boolean>(false);

	const { id } = useParams();

	const [query, setQuery] = useState<string>("");
	const debouncedQuery = useDebounce(query, 400);

	const handleSwitch = () => {
		if (id) {
			if (admin) {
				setSureModal(true);
			} else {
				dispatch(setAdmin(id));
			}
		}
	};

	const continueUnsetAdmin = () => {
		dispatch(unsetAdmin(id));
		setSureModal(false);
	};

	return (
		<div className="step-wrapper">
			<UserRolesHeader query={query} handleQuery={(e) => setQuery(e.target.value)} handleSwitch={handleSwitch} />
			<UserRolesTable query={debouncedQuery} />

			{sureModal && <SureModal callback={continueUnsetAdmin} close={() => setSureModal(false)} />}
		</div>
	);
};

export default UserRoles;
